import type { BoardObject } from '../../core/interfaces/board-object.interface.js';
import type { CheckboxObject } from './checkbox.interface.js';

/**
 * Type-narrowing guard for checkbox board objects (TR2).
 *
 * Null- and undefined-safe per PRD-F2 T3 to keep registry fallbacks
 * (FC10) from throwing on absent payloads.
 */
export function isCheckbox(
  obj: BoardObject | null | undefined,
): obj is CheckboxObject {
  return obj != null && obj.type === 'checkbox';
}
